import { gql } from '@apollo/client';

export const GET_CURRENT_RECKONING = gql`
  query currentReckoning {
    currentReckoning {
      _id
      invitation
      onboardingDoneWhenThisReckoningIsDone
      allowAnonymousUser
      allowRegistration
      explanationForAnonymousUser
      redirectionPage
      resultFeature
      resultRecommendationStrategy
      session {
          _id
      }
    }
  }
`;


export const GET_RECKONING = gql`
  query reckoningById($id: String!) {
    reckoning(id: $id) {
      _id
      invitation
      onboardingDoneWhenThisReckoningIsDone
      allowAnonymousUser
      allowRegistration
      alreadyDone
      explanationForAnonymousUser
      redirectionPage
      resultFeature
      resultRecommendationStrategy
      session {
        _id
      }
    }
  }
`;

export const GET_PUBLIC_RECKONING = gql`
  query publicReckoningById($id: String!) {
    retrievePublicReckoning(reckoning: $id) {
      _id
      invitation
      onboardingDoneWhenThisReckoningIsDone
      allowAnonymousUser
      allowRegistration
      explanationForAnonymousUser
      alreadyDone
      redirectionPage
      resultFeature
      resultRecommendationStrategy
      session {
        _id
      }
    }
  }
`;


export const IS_RECKONING_AVAILABLE = gql`
  query isReckoningAvailable($reckoning: String!) {
    isReckoningAvailable(reckoning: $reckoning) 
  }
`;


